export const createBfzArticleTeaserLink = (article, ressort) =>
  `/fachzeitschriften/${article.ressort || ressort}/${
    article.topic_data.slug
  }/${article.slugline}-${article.gt_id}`
